import { useEffect, useState } from 'react';
import { usePostTokenCreate } from '@repo/api/endpoints/token';
import { ApiClient } from '@repo/api/client';
import { useGetHashFromIframe } from './use-get-hash-from-iframe';
/**
 * These queries must not be parallel. The tokenCreate query depends on the response from the hash query.
 */
export var getQueriesStatus = function (hashStatus, tokenCreateStatus) {
    if (hashStatus === 'idle' && tokenCreateStatus === 'idle') {
        return 'idle';
    }
    if ((hashStatus === 'pending' && tokenCreateStatus === 'idle') ||
        (hashStatus === 'success' && tokenCreateStatus === 'idle') ||
        (hashStatus === 'success' && tokenCreateStatus === 'pending')) {
        return 'pending';
    }
    if (hashStatus === 'success' && tokenCreateStatus === 'success') {
        return 'success';
    }
    return 'error';
};
export function useObtainAuthToken() {
    var _a = useGetHashFromIframe(), iframeHash = _a.iframeHash, hashStatus = _a.hashStatus;
    var _b = useState('idle'), status = _b[0], setStatus = _b[1];
    var _c = usePostTokenCreate(), mutateToken = _c.mutate, dataToken = _c.data, tokenCreateStatus = _c.status;
    useEffect(function () {
        if (iframeHash) {
            mutateToken({ payload: { hash: iframeHash } }, {
                onSuccess: function (_a) {
                    var token = _a.token;
                    ApiClient.updateFetcher({
                        headers: { Authorization: "Bearer ".concat(token) },
                    });
                },
            });
        }
    }, [iframeHash, mutateToken]);
    useEffect(function () {
        setStatus(getQueriesStatus(hashStatus, tokenCreateStatus));
    }, [hashStatus, tokenCreateStatus]);
    return {
        token: dataToken === null || dataToken === void 0 ? void 0 : dataToken.token,
        hash: iframeHash,
        status: status,
    };
}
